import type { SelectedBundleOptionValue } from "@jti/magento";

import { QTY_MULTIPLY_SYMBOL } from "../../const";

import styles from "./BundleOptionRow.module.scss";

type BundleOptionRowsProps = {
  values: SelectedBundleOptionValue[];
};

const LIST_BULLET_SYMBOL = "·";

export const BundleOptionRows = ({ values }: BundleOptionRowsProps) => (
  <>
    {values.map((option) => {
      const productName = "label" in option ? option.label : option.product_name;

      return (
        <div key={`option-${productName}-${option.id}`} className={styles.option}>
          <span>
            {LIST_BULLET_SYMBOL} {option.quantity}
            {QTY_MULTIPLY_SYMBOL}
          </span>
          <span>{productName}</span>
        </div>
      );
    })}
  </>
);
